import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared/services/httpclient.service";
import { ScanPointTimeScanRequest } from "./ScanPointTimeScanRequest";
import { ScanPointManualTableRequest } from "./ScanPointManualTableRequest";
import { HallPassInsertRequest } from "./HallPassInsertRequest";
import { HallPassUpdateRequest } from "./HallPassUpdateRequest";

@Injectable()
export class TimeScanningService {
	constructor(private httpclientService: HttpclientService) {}

	ScanPointSelectPreferences() {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointSelectPreferences";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointTimeScanInsert(parms: ScanPointTimeScanRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointTimeScanInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualSchoolSelectList() {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointManualSchoolSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualContainerSelectList() {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointManualContainerSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualFacilitySelectList() {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointManualFacilitySelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualDynamicGroupSelectList(AudienceID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DynamicGroupsGetList?ApplicationItemID=&AudienceID=" + AudienceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualDynamicValueSelectList(applicationItemID, DynamicGroupSQL, SchoolID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DynamicValuesGetList?ApplicationItemID=" + applicationItemID + "&DynamicGroupSQL=" + DynamicGroupSQL + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualTableSelectList(parms: ScanPointManualTableRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointManualTableSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualExtendedSelect(PersonID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointManualExtendedSelect?PersonID=" + PersonID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointManualOptionsSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointManualOptionsSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//
	// From Old Page
	//

	LoadAlertsForPerson(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/LoadAlertsForPerson?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RecentAttendanceGetList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/RecentAttendanceGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RecentIDHistoryGetList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/RecentIDHistoryGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DayOptionSelectList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DayOptionSelectList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DayOptionByFacilityIDSelectList(ApplicationItemID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DayOptionByFacilityIDSelectList?ApplicationItemID=" + ApplicationItemID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScheduleInfoGetList(ApplicationItemID, PersonID, Option) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScheduleInfoGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID + "&Option=" + Option;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassInfoGetList(PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassInfoGetList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadHallpassReasonList(applicationItemID, facilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallpassReasonGetList?ApplicationItemID=" + applicationItemID + "&FacilityID=" + facilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadClassAttendanceExcuseSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ClassAttendanceExcuseSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadFacilityLocationList(applicationItemID, facilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/FacilityLocationGetList?ApplicationItemID=" + applicationItemID + "&FacilityID=" + facilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassInsert(parms: HallPassInsertRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassReprint(HallpassID, IDPrinterID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassReprint?HallpassID=" + HallpassID + "&IDPrinterID=" + IDPrinterID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassUpdate(parms: HallPassUpdateRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanPointGetScanSound(FacilityID, SoundLibraryID, Success) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScanPointGetScanSound?FacilityID=" + FacilityID + "&SoundLibraryID=" + SoundLibraryID + "&Success=" + Success;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
